import * as React from 'react';
import { SVGProps } from 'react';

const IconDrillingPartLeftFilledSizeXs = (props: SVGProps<SVGSVGElement>) => (
  <svg viewBox="0 0 12 12" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path d="M11 6a5.02 5.02 0 0 0-4.511-5v10A5.02 5.02 0 0 0 11 6ZM5.486 6.502V11A5.02 5.02 0 0 1 1 6.502h4.486ZM1 5.498A5.02 5.02 0 0 1 5.486 1v4.498H1Z" />
  </svg>
);
export default IconDrillingPartLeftFilledSizeXs;
